import { createRouter, createWebHashHistory } from 'vue-router'
import LayoutContainer from '../views/layout/LayoutContainer.vue'
import LoginView from '../views/login/LoginView.vue'
import UserManagement from '../views/user/UserManagement.vue'
import RoleManagement from '../views/role/RoleManagement.vue'
import DashboardView from '../views/DashboardView.vue'
import InvestorDashboardView from '../views/InvestorDashboardView.vue'
import store from '../store'
import { ElMessage } from 'element-plus'
import {isTokenExpired, removeToken} from "@/utils/auth";
import StoreEveList from "@/views/report/StoreEveList.vue";
import StoreDetail from "@/views/asset/StoreDetail.vue";
import TenantManagement from "@/views/asset/TenantManagement.vue";
import BrandManagement from "@/views/asset/BrandManagement.vue";
import BrandDetail from "@/views/asset/BrandDetail.vue";
import StoreEvaluate from "@/views/report/StoreEvaluate.vue";
import storeList from "@/views/asset/StoreList.vue";
import AfterInvestAssetRisk from "@/views/asset/AfterInvestAssetRisk.vue";
import AccountManagement from "@/views/account/AccountManagement.vue";
import PostInvestTodo from "@/views/asset/PostInvestTodo.vue";
import ManualPaymentWriteOff from "@/views/asset/ManualPaymentWriteOff.vue";
import DataFix from "@/views/asset/DataFix.vue";
import KeruyunCreditOrderList from '@/views/saas/KeruyunCreditOrderList.vue';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/',
    component: LayoutContainer,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/dashboard'
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        component: DashboardView
      },
      {
        path: '/investor/dashboard',
        name: 'investorDashboard',
        component: InvestorDashboardView
      },
      {
        path: '/system/user',
        name: 'userManagement',
        component: UserManagement,
        meta: { permission: 'sys:user' }
      },
      {
        path: '/system/role',
        name: 'roleManagement',
        component: RoleManagement,
        meta: { permission: 'sys:role' }
      },
      {
        path: '/asset/evaluateList',
        name: 'storeEvaluateList',
        component: StoreEveList,
        meta: { permission: 'asset:storeEvaluate' } // 权限标识，根据实际情况调整
      },
      {
        path: '/asset/storeDetail/:storeEntCode',
        name: 'storeDetail',
        component: StoreDetail,
        meta: { permission: 'asset:store' } // 权限标识，根据实际情况调整
      },{
        path: '/system/tenant',
        name: 'tenantManagement',
        component: TenantManagement,
        meta: { permission: 'sys:tenant' }
      },{
        path: '/business/brand',
        name: 'businessManagement',
        component: BrandManagement,
        meta: { permission: 'business:brandManage' }
      },{
        path: '/business/brandDetail/:brandCode',
        name: 'brandDetail',
        component: BrandDetail,
        meta: { permission: 'brand:view' }
      },
      {
        path: '/store/evaluate/:storeEntCode',
        name:'StoreEvaluate',
        component: StoreEvaluate,
        props: true
      },
      {
        path: '/business/store',
        name:'StoreList',
        component: storeList,
        props: true
      },
      {
        path: '/afterInvest/assetRisk',
        name: 'AfterInvestAssetRisk',
        component: AfterInvestAssetRisk,
        props: true
      },
      {
        path: '/afterInvest/todo',
        name: 'PostInvestTodo',
        component: PostInvestTodo,
        meta: { permission: 'postInvest:todo' }
      },
      {
        path: '/afterInvest/manualPaymentWriteOff',
        name: 'ManualPaymentWriteOff',
        component: ManualPaymentWriteOff,
        meta: { permission: 'postInvest:manualPaymentWriteOff' }
      },
      {
        path: '/afterInvest/dataFix',
        name: 'DataFix',
        component: DataFix,
        meta: { permission: 'postInvest:dataFix' }
      },
      {
        path: '/system/account',
        name: 'accountManagement',
        component: AccountManagement,
        meta: { permission: 'sys:account:view' }
      },
      {
        path: '/saas/keruyun/creditOrder',
        name: 'keruyunCreditOrder',
        component: KeruyunCreditOrderList,
        meta: { permission: 'saas:keruyun' }
      }
    ]
  }
]



const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 判断是否需要登录权限
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 检查是否已登录
    if (!store.state.token) {
      // 未登录，跳转到登录页
      next('/login')
      ElMessage.warning('请先登录')
    } else {
      // 已登录，直接放行（权限由后端控制）
      // 有 Token：检查有效期
      if (isTokenExpired()) {
        // 过期：清除登录状态 + 跳转登录
        removeToken()
        store.commit('SET_TOKEN', '')
        ElMessage.error('登录已过期，请重新登录')
        next('/login')
        return
      }
      next()
    }
  } else {
    // 不需要登录的页面直接放行
    next()
  }
})

export default router
